<template>
  <div id="appNavbar">
    <v-navigation-drawer v-model="sideNav" fixed temporary color="#fffcf5">
      <v-layout wrap>
        <v-flex xs12 text-left py-2 text-uppercase align-self-center>
          <v-list dense v-for="main in menus2" :key="main._id">
            <v-layout wrap v-if="main.subMenu">
              <v-flex xs12 py-2>
                <v-list-group no-action :value="false" active-class="activated">
                  <template v-slot:activator>
                    <v-list-item-title
                      style="
                        font-size: 13px;
                        letter-spacing: 2px;
                        color: black;
                        cursor: pointer;
                        font-family: poppinssemibold;
                      "
                      >{{ main.name }}
                    </v-list-item-title>
                  </template>
                  <v-flex xs12 py-2 px-4>
                    <div style="border-bottom: 1px solid black"></div>
                  </v-flex>
                  <template v-for="sub in main.subMenu">
                    <v-flex xs12 text-left pl-4 :key="sub._id">
                      <v-layout wrap justify-center>
                        <v-flex xs12>
                          <router-link :to="sub.route">
                            <span
                              :style="
                                $route.path == sub.route
                                  ? {
                                      'font-family': 'poppinsbold',
                                      'font-size': ' 16px',
                                    }
                                  : {
                                      'font-family': 'poppinssemibold',
                                      'font-size': ' 13px',
                                    }
                              "
                              style="
                                color: black;
                                letter-spacing: 3px;
                                cursor: pointer;
                              "
                            >
                              {{ sub.name }}
                            </span>
                          </router-link>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 py-2 px-4 :key="sub._d">
                      <div style="border-bottom: 1px solid black"></div>
                    </v-flex>
                  </template>
                </v-list-group>
                <!-- <v-list-group v-else> -->
              </v-flex>
            </v-layout>
            <v-layout wrap v-else>
              <v-flex xs12>
                <v-list-item-group active-class="activated">
                  <v-list-item>
                    <v-list-item-content>
                      <router-link :to="main.route">
                        <template>
                          <v-list-item-title
                            :style="
                              $route.path == main.route
                                ? {
                                    'font-family': 'poppinsbold',
                                    'font-size': ' 16px',
                                  }
                                : {
                                    'font-family': 'poppinssemibold',
                                    'font-size': ' 13px',
                                    'letter-spacing': '2px',
                                    cursor: 'pointer',
                                    color: 'black;',
                                  }
                            "
                            v-text="main.name"
                          ></v-list-item-title>
                        </template>
                      </router-link>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-flex>
            </v-layout>

            <!-- </v-list-group> -->
          </v-list>
        </v-flex>
      </v-layout>
      <!-- <v-layout wrap justify-center>
        <v-flex
          xs12
          v-for="(item, i) in appNavItems"
          :key="i"
          text-center
          pa-2
          pl-0
          text-none
          align-self-center
        >
          <v-layout wrap justify-center>
            <v-flex xs12 px-0 pl-2 align-self-center text-left>
              <router-link :to="item.route">
                <v-icon>{{ item.icon }}</v-icon>
                <span
                  :style="
                    $route.path == item.route
                      ? {
                          'font-family': 'poppinsbold',
                        }
                      : {
                          'font-family': 'poppinslight',
                        }
                  "
                  style="
                    font-size: 15px;
                    color: black;
                    letter-spacing: 3px;
                    cursor: pointer;
                  "
                >
                  {{ item.name }}
                </span>
              </router-link>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
    </v-navigation-drawer>

    <v-app-bar
      app
      dark
      color="#292626"
      dense
      flat
      height="50px"
      class="hidden-lg-and-up"
    >
      <v-app-bar-nav-icon
        v-if="$route.path != '/privacypolicies'"
        @click.native="sideNav = !sideNav"
      >
        <v-icon color="white">mdi-menu</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <router-link to="/">
          <v-layout wrap justify-center>
            <v-flex xs12>
              <span
                style="
                  font-family: poppinsbold;
                  font-size: 20px;
                  cursor: pointer;
                  color: #81fd48;
                "
              >
                All Mart
              </span>
            </v-flex>
          </v-layout>
        </router-link>
      </v-toolbar-title>
    </v-app-bar>
    <v-app-bar
      color="#292626"
      elevation="0"
      height="70px"
      class="hidden-md-and-down"
    >
      <v-layout wrap justify-center fill-height>
        <v-flex xs1 align-self-center>
          <router-link to="/">
            <v-layout wrap>
              <v-flex xs12>
                <span
                  style="
                    font-family: poppinsbold;
                    font-size: 20px;
                    cursor: pointer;
                    color: #81fd48;
                  "
                >
                  All Mart
                </span>
              </v-flex>
              <!-- <v-flex xs5>
                <v-img
                  height="30px"
                  width="30px"
                  src="../assets/logo.png"
                ></v-img>
              </v-flex> -->
            </v-layout>
          </router-link>
        </v-flex>
        <v-spacer></v-spacer>

        <v-flex
          v-if="$route.path != '/privacypolicies'"
          xs6
          lg1
          xl1
          px-4
          text-center
          align-self-center
        >
          <AccountMenu />
        </v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
import AccountMenu from "./../components/accountMenu";
export default {
  components: {
    AccountMenu,
  },
  data() {
    return {
      sideNav: false,
      admin: [{ name: "ADMINS", route: "/Admins" }],

      menus2: [
        {
          name: "Dashboard",
          route: "/",
          // subMenu: [
          //   {
          //     name: "dashboard",
          //     route: "/",
          //   },
          // ],
        },
        {
          name: "Food",
          subMenu: [
            {
              name: "Category",
              route: "/ProductType",
            },
            {
              name: "Products",
              route: "/Food",
            },
            {
              name: "Orders",
              route: "/OrderList",
            },
            {
              name: "Offers",
              route: "/offers",
            },
            {
              name: "sales Analysis",
              route: "/salesAnalytics",
            },
            {
              name: "Delivery Charges",
              route: "/deliveryCharges",
            },
            {
              name: "Advertisements",
              route: "/advertisements",
            },
          ],
        },
        {
          name: "Grocery",
          subMenu: [
            {
              name: "Category",
              route: "/Gocerycategory",
            },
            {
              name: "Product List",
              route: "/Groceryproduct",
            },
            {
              name: "Stock Management",
              route: "/Stocksmanagement",
            },
            {
              name: "Orders",
              route: "/groceryOrderList",
            },
             

             {
              name: "Deals",
              route: "/deals?Type=grocerydeals",
            },


             {
              name: "Delivery ",
              route: "/delivery",
            },
            {
              name: "Banner",
              route: "/groceryBanner?Type=MainBanner",
            },
            {
              name: "Small Banner",
              route: "/groceryBanner?Type=SmallBanner",
            },
            {
              name: "Product Banner",
              route: "/groceryBanner?Type=ProductBanner",
            },
            {
              name: "Bottom Banner",
              route: "/groceryBanner?Type=BottomBanner",
            },
          ],
        },

        {
          name: "User List",
          subMenu: [
            {
              name: "Customers",
              route: "/CustomerList",
            },
            {
              name: "Food Sellers",
              route: "/SellerList",
            },
            {
              name: " Grocery Sellers",
              route: "/GocerySeller",
            },
          ],
        },
        {
          name: "Terms and conditions",
          subMenu: [
            {
              name: "Privacy policy",
              route: "/privacypolicy",
            },
            {
              name: "Cancellation policy",
              route: "/cancellationPolicy",
            },
            {
              name: "Terms and conditions",
              route: "/termsandconditions",
            },
          ],
        },

        {
          name: "Promo code",
          route: "/promocode",
        
        },
        {
          name: "HSN Code",
          route: "/HSNList",
         
        },
          {
          name: "News",
          route: "/news",
         
        },
        

       
      ],





      menus: [
        {
          name: "Dashboard",
          subMenu: [
            {
              name: "dashboard",
              route: "/",
            },
          ],
        },
        {
          name: "Orders",
          subMenu: [
            {
              name: "Orders",
              route: "/OrderList",
            },
          ],
        },
        {
          name: "User List",
          subMenu: [
            {
              name: "Customer List",
              route: "/CustomerList",
            },
            {
              name: "Seller List",
              route: "/SellerList",
            },
          ],
        },
        {
          name: "Category",
          subMenu: [
            {
              name: "Category",
              route: "/ProductType",
            },
          ],
        },
        {
          name: "Products",
          subMenu: [
            {
              name: "Products",
              route: "/Food",
            },
          ],
        },

        {
          name: "Terms and conditions",
          subMenu: [
            {
              name: "Privacy policy",
              route: "/privacypolicy",
            },
            {
              name: "Cancellation policy",
              route: "/cancellationPolicy",
            },
            {
              name: "Terms and conditions",
              route: "/termsandconditions",
            },
          ],
        },
        {
          name: "Offers",
          subMenu: [
            {
              name: "Offers",
              route: "/offers",
            },
          ],
        },
        {
          name: "Sales Analysis",
          subMenu: [
            {
              name: "sales Analysis",
              route: "/salesAnalytics",
            },
          ],
        },
      ],
    };
  },
  computed: {
    appUser() {
      return null;
    },
    appMenu() {
      // console.log("menus", store.state.menus);
      return this.$store.state.menus;
    },
    appLogin() {
      return false;
    },
    appType() {
      return this.$store.state.userType;
    },
    appNavItems() {
      return this.navItems;
    },
  },
};
</script>

<style>
input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: poppinsregular !important;
}
.searchBox .v-input__control {
  min-height: 10px !important;
}
.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}
</style>

